import { useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

// Generate a simple visitor ID stored in localStorage
const getVisitorId = (): string => {
  let id = localStorage.getItem("louve_visitor_id");
  if (!id) {
    id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2);
    localStorage.setItem("louve_visitor_id", id);
  }
  return id;
};

export const usePageTracking = () => {
  const location = useLocation();

  const trackVisit = useCallback(async (path: string) => {
    try {
      // Only count one visit per browser session (tab open)
      const sessionKey = "louve_session_tracked";
      if (sessionStorage.getItem(sessionKey)) {
        return; // Already tracked this session
      }
      sessionStorage.setItem(sessionKey, "true");

      await supabase.from("page_visits" as any).insert({
        page_path: path,
        visitor_id: getVisitorId(),
        user_agent: navigator.userAgent?.substring(0, 255) || "",
      } as any);
    } catch {
      // Silent fail - tracking should never break the app
    }
  }, []);

  useEffect(() => {
    trackVisit(location.pathname);
  }, [location.pathname, trackVisit]);
};
